import axios from 'axios';
import Vue from 'vue';
// import { errorHandler } from "../exports/error_management";

// import { buildQuery } from '../exports/queryStringBuilder'
// const getHash = () =>
//     Date.now().toString(36) + Math.random().toString(36).substring(2)

const state = {
    holidays: [],
    pagination: null,
    holidaysNotPaginated : []
}



const mutations = {

    clearholidays(state) {
        state.holidays = []; 
    },

    SET_HOLIDAYS(state, schedules) {
        state.holidays = schedules;
    },
    SET_HOLIDAYS_NOT_PAGINATED(state, schedules) {
        state.holidaysNotPaginated = schedules;
    },
    ADD_HOLIDAY(state, schedule) {
        state.holidays.push(schedule);
    },
    UPDATE_HOLIDAY(state, updatedSchedule) {
        const index = state.holidays.findIndex(schedule => schedule.id === updatedSchedule.id);
        if (index !== -1) {
            Vue.set(state.holidays, index, updatedSchedule);
        }
    },
    DELETE_HOLIDAY(state, scheduleId) {
        state.holidays = state.holidays.filter(schedule => schedule.id !== scheduleId);
    },
    SET_PAGINATION(state, pag) {
        state.pagination = pag;
      },


}

const actions = {
   
    async fetchholidays({ commit },params) {
        let {  page: pg } = params || {}
       
        pg = pg || 0
       
        const response = await axios.get(`holiday?page=${pg}`);
        
        let value = response.data.success.data;
        if(pg > 0) {
            const {
                data: _document = [],
                current_page: page,
                per_page: pageSize = 15,
                total = 0,
            } = value || {};
            commit("SET_PAGINATION", {
                page,
                pageSize,
                total,
            });
            commit('SET_HOLIDAYS',_document);
        } else {
            commit('SET_HOLIDAYS_NOT_PAGINATED',[]);
            commit('SET_HOLIDAYS_NOT_PAGINATED',value);
        }
    },

    async addHoliday({ commit },{ schedule}) {
        
        const response = await axios.post(`holiday`, schedule);
        commit('ADD_HOLIDAY', response.data.success.data);
    },
    async updateHoliday({ commit }, { schedule }) {
        
        const response = await axios.put(`holiday/${schedule.id}`, schedule);
        commit('UPDATE_HOLIDAY', response.data.success.data);
    },
    async deleteHoliday({ commit }, { schedule }) {
       
        await axios.delete(`holiday/${schedule}`);
        commit('DELETE_HOLIDAY', schedule);
    },

    async sampleExcel() {
        try {
          
       
          const response = await axios.get(`holiday/sample-excel`,{
            responseType: 'blob'
        });
         
         
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Holiday.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error("Error fetching request:", err);
        }
      },
      excelImport(_,payload) {
        return axios.post(`holiday/import-excel`,payload)
            .then(results => {
                console.log('createdResults', results)
            })
            .catch(err => {
                errorHandler(err)
            })
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
  
}
